<template>
  <router-view />
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from './stores/auth';
import { useEstateStore } from './stores/estate';
import { usePushNotifications } from './composables/usePushNotifications';

const authStore = useAuthStore();
const estateStore = useEstateStore();
const router = useRouter();
const { subscribe } = usePushNotifications();

onMounted(async () => {
  if (!authStore.isAuthenticated) return;

  const wasSecurityGuard = authStore.isSecurityGuard;
  await Promise.all([authStore.refreshProfile(), estateStore.refreshBranding()]);

  // If the cached type was wrong and the DB corrected it, navigate to the right place
  if (!wasSecurityGuard && authStore.isSecurityGuard) {
    router.replace({ name: authStore.gatePost ? 'security-dashboard' : 'select-post' });
  }

  // Subscribe to push notifications so panic alerts wake the app when backgrounded
  subscribe();
});
</script>
